import { createSelector } from 'reselect';
import { getSizotsaFuneralClaim } from './index';
import { FORM_STATUS } from '../../reducers/status';
import { getDeceasedDetailsForm } from './deceasedDetails';
import { calculateAge } from '../../functions/easiplusFuneralPlan/Util';

export const getClaimentDetails = createSelector(
    getSizotsaFuneralClaim,
    (sizotsaFuneralClaim) => sizotsaFuneralClaim.claimentDetails
);
export const getClaimentDetailsForm = createSelector(getClaimentDetails, (claimentDetails) => claimentDetails.form);
const makeGetField = (fieldId) =>
    createSelector(getClaimentDetailsForm, (claimentDetailsForm) => claimentDetailsForm[fieldId]);

export const getFirstName = makeGetField('firstName');
export const getClaimentType = makeGetField('claimentType');
export const idSelected = makeGetField('idSelected')


const policyHolderDocuments = [
    { name: 'proofOfAddress', description: 'Proof of address' },
    { name: 'deathCertificate', description: 'Certified Copy of Death certificate' },
    { name: 'letterOfMortuary', description: 'Letter From The Mortuary' },
    { name: 'medicalCertificateFile', description: 'Medical Certificate Report' },
    { name: 'idCopyOfClaimantFile', description: 'ID Copy Of Claimant' },
    { name: 'idOfDeceasedFile', description: 'ID Of Deceased' },
    {name: 'policeReport', description: 'Police Report In case of Accident or Sucide'},
    { name: 'birthCertificate', description: 'Birth Certificate and Adoption Certificate In case of Minor' },
    // { name: 'adoptionCertificate', description: 'Adoption Certificate' }
];
const beneficiaryDocs = [
    ...policyHolderDocuments,
    { name: 'beneficiaryId', description: 'Certified copy of Beneficiary ID' },
    { name: 'confirmationOfBankAccount', description: 'Confirmation of bank account' },
];
const executorDocs = [
    ...policyHolderDocuments,
    { name: 'affidavit', description: 'Affidavit of the authorize(nominating someone to make the claim)' },
    { name: 'confirmationOfBankAccount', description: 'Confirmation of bank account' },
];
const uploadDocumentsByClaimentType = {
    '01': policyHolderDocuments,
    '02': beneficiaryDocs,
    '03': executorDocs,
};
export const getDocumentsToBeUploaded = createSelector(
    getClaimentType,
    (claimentType) => uploadDocumentsByClaimentType[claimentType.value]
);

export const getClaimentDetailsValid = createSelector(
    getClaimentDetails,
    (claimentDetails) => claimentDetails.formStatus === FORM_STATUS.VALID
);

export const getClaimentDetailsValidations = createSelector(getClaimentDetailsForm, (claimentDetailForm) => {
    const {
        claimentType,
        firstName,
        lastName,
        idNumber,
        relationshipToPolicyHolder,
        streetAddress,
        city,
        district,
        residentialDuration,
        occupation,
        policyNumber,
        dateOfBirth,
        accountHolderId,
        accountHolderName,
        bank,
        bankBranch,
        accountNumber,
        accountType,
        title,
        idSelected,
        nationality,
        country,
        email,
        mobileNumber,
        residenceTimePeriod,
        previousPostalAddress,
        previousPostalCity,
        previousPostalCountry,
        postalSuburb,
        postalCity,
        postalCountry,
        employeeOccupation,
        otherEmployeeOccupation
    } = claimentDetailForm;
    const policyHolderDetailsFormFields = {
        title,
        firstName,
        lastName,
        // policyNumber,
        dateOfBirth,
        idSelected,
        accountHolderId,
        nationality,
        country,
        city,
        email,
        mobileNumber,
        streetAddress,
        // residenceTimePeriod,
        // employeeOccupation,
        // ...(employeeOccupation?.value==="Other" && {otherEmployeeOccupation}),
        // ...(residenceTimePeriod?.value==="Less than two years" && {previousPostalAddress,previousPostalCity,previousPostalCountry}),
        bank,
        bankBranch,
        accountNumber,
        accountType,
        accountHolderName
    };
    const defaultFormFields = { claimentType };
    const beneficiaryDetailsFormFields = {
        title,
        firstName,
        lastName,
        idSelected,
        accountHolderId,
        relationshipToPolicyHolder,
        streetAddress,
        city,
        email,
        country,
        dateOfBirth,
        // residenceTimePeriod,
        // ...(residenceTimePeriod?.value==="Less than two years" && {previousPostalAddress,previousPostalCity,previousPostalCountry}),
        // employeeOccupation,
        // ...(employeeOccupation?.value==="Other" && {otherEmployeeOccupation}),
        accountHolderName,
        bank,
        bankBranch,
        accountNumber,
        accountType
    };
    const executorDetailsFormFields = beneficiaryDetailsFormFields;
    const claimentDetailsFormFields = {
        Beneficiary: beneficiaryDetailsFormFields,
        'Policy holder': policyHolderDetailsFormFields,
        Executor: executorDetailsFormFields,
        default: defaultFormFields,
    };
    return claimentDetailsFormFields[claimentType.displayValue ?? 'default'];
});



       

const inputFieldLabels = {
    claimentType:'Claiment Type',
    relationshipToPolicyHolder:'Relationship to policy holder',
    policyNumber:'Policy number',
    dateOfBirth:'Date of birth',
    accountHolderName:'Account holder name',
    bank:'Bank name',
    bankBranch:'Branch name',
    accountNumber:'Account number',
    accountType:'Account type',
    accountHolderId:'ID number',
    nationality:'Nationality',
    email:'Email address',
    mobileNumber:'Contact number',
    streetAddress: 'Plot number/suburb/ward',
    city: 'City/Town/Village',
    country: 'Country',
    residenceTimePeriod: 'How long have you been living in this address?',
    previousPostalAddress: 'Previous plot number/suburb/ward',
    previousPostalCity: 'Previous City/Town/Village',
    previousPostalCountry: 'Previous Country',
    postalSuburb: 'P O Box/Private Bag/Suburb/Ward',
    postalCity: 'Postal City/Town/Village',
    postalCountry: 'Postal Country',
    employeeOccupation:'Employee occupation',
    otherEmployeeOccupation:'Other Employee occupation' 
    
};
export const getClaimentDetailsSummary = createSelector(
    getClaimentDetailsValidations,
    (formFieldsFiltered) => {
        const fullName = formFieldsFiltered['title']?.value+ ' ' +formFieldsFiltered['firstName']?.value + ' '+ (formFieldsFiltered['middleName']?.value ?? '') + ' ' + formFieldsFiltered['lastName']?.value
        const claimentDetailsSummary= Object.keys(formFieldsFiltered).flatMap((item) => {
            return {
                label: inputFieldLabels[item],
                value: formFieldsFiltered[item]?.displayValue ?? '-',
            };
        }).filter(({label})=>label);
        return [{label:'Full name',value:fullName}, ...claimentDetailsSummary, ]
    }
);